import { render, staticRenderFns } from "./AtomParagraph.vue?vue&type=template&id=2cf669bc"
import script from "./AtomParagraph.vue?vue&type=script&lang=js"
export * from "./AtomParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports